import RundownItemBase from '../../rundown/controllers/rundown_item_base_ctrl'

export default class ItemPlannerItemFormCtrl extends RundownItemBase {

    constructor (
        Contact,
        $scope,
        $rootScope,
        $mdDialog,
        $http,
        $mdToast,
        $state,
        $stateParams,
        $timeout,
        widgets,
    ) {
        super(
            Contact,
            $http,
            $scope,
            $state,
            $timeout,
        )

        // Dependencies
        this.$rootScope = $rootScope
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.$stateParams = $stateParams
        this.widgets = widgets

        // Controller vars
        this.item = {}

        this.date = null
        this.plannedCampaigns = []
        this.formdata = {}
        this.selectedCampaign = null

        if ($stateParams.itemId) {
            this.itemId = $stateParams.itemId
            this.type = 'update'

        } else {
            this.type = 'create'
            this.formdata.block_id = $stateParams.blockId

            if ($stateParams.afterItemId) {
                this.formdata.afterItemId = $stateParams.afterItemId
            }
        }

        $scope.$on('item_contact_updated', this.contactUpdate.bind(this))

        this.fetch().then()
    }

    fetch () {
        const {
            type,
            itemId,
            $stateParams,
            $http,
        } = this

        return new Promise(resolve => {
            if (type === 'create') {
                if ($stateParams.createInDate) {
                    this.date = $stateParams.createInDate
                } else {
                    this.date = moment().format('YYYY-MM-DD')
                }

                return resolve()
            }

            let findItemUri = `items/find/${encodeURIComponent(itemId)}`
            findItemUri += `?with[]=contacts&with[]=tags`
            $http.get(findItemUri).then((response) => {
                const item = this.item = response.data
                this.date = moment(item.start).format('YYYY-MM-DD')
                this.formdata = response.data

                resolve()

                if (this.type === 'update') {
                    this.selectedCampaign = item.campaign_id
                }

                if (this.type === 'createAfter') {
                    this.blockId = item.block_id
                }
            })
        })
            .then(async () => {
                const response = await $http.get('item-planner/campaigns/' + this.date)
                this.plannedCampaigns = response.data
            })
            .then(() => super.fetch())
    }

    setCampaign () {
        this.item.campaign_id = this.selectedCampaign
        this.formdata.campaign_id = this.selectedCampaign
    }

    initView () {
        this.setFormData()
        this.loaded = true
        this.detailsLoaded = true
    }

    destroy () {

    }

    setFormData () {
        if (!this.selectedCampaign) {
            if (this.$rootScope.selectedCampaign) {
                this.selectedCampaign = this.$rootScope.selectedCampaign
                this.setCampaign()
            }
        }
        if (!this.formdata.tags) {
            this.formdata.tags = []
        }

        if (!this.formdata.duration) {
            this.formdata.duration = 60
        }

        if (!this.formdata.model_type_id) {
            this.formdata.model_type_id = this.customFieldsRaw[0].id
        }
    }

    saveFinished (item, isUpdate) {
        const { $rootScope, $mdToast } = this
        $rootScope.$broadcast('item-planner_item_saved', isUpdate, item)

        let toast = 'create'
        if (isUpdate) {
            toast = 'saved'
            $rootScope.$broadcast('item-planner_item-update_' + item.id, item)
        }

        $mdToast.show({
            templateUrl: `/partial/app.partials.toasts.${toast}?object=item&title=${encodeURIComponent(item.title)}`,
            hideDelay: 3000,
            position: ('top right')
        })

        this.redirectBack()
    }

    save () {
        this.widgets.saveWidgetsForTypeId('item-' + this.$state.params.itemId)
            .then(() => {
                if (this.type === 'update') {
                    this.$http.patch('/items/' + this.formdata.id, this.formdata)
                        .then(response => this.saveFinished(response.data, true))

                } else {
                    const data = {
                        ...this.formdata,
                        placeOnEndOfBlock: false,
                    }

                    if (!data.afterItemId) {
                        data.afterItemId = null
                        data.placeOnEndOfBlock = true
                    }

                    this.$http.post('/items', data)
                        .then(response => this.saveFinished(response.data, false))
                }
            })
    }

    redirectBack () {
        this.$state.go('item-planner')
    }

}

ItemPlannerItemFormCtrl.$inject = [
    'Contact',
    '$scope',
    '$rootScope',
    '$mdDialog',
    '$http',
    '$mdToast',
    '$state',
    '$stateParams',
    '$timeout',
    'widgets'
]
